require('./brokerTodayKeys.scss');
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');
const { ContentBox } = require('commonsComponents/contentBox');

class BrokerTodayKeys extends React.Component {
    buildDateBlock(date) {
        if (date) {
            return (
                <div className="broker-today-keys__article-period">
                    <i className="icon broker-today-keys__icon-calendar"></i>
                    <span className="broker-today-keys__article-date">
                        {date}
                    </span>
                </div>
            )
        }
    }

    render() {
        const { brokerTodayNews } = this.props;

        const articlesBlock = brokerTodayNews.map((article, index) => {
            return (
                <article key={index} className="broker-today-keys__article">
                    <header className="broker-today-keys__article-header">
                        <h2 className="broker-today-keys__article-title">
                            {article.title}
                        </h2>
                    </header>
                    <hr className="broker-today-keys__divider"/>
                    <section>
                        {this.buildDateBlock(article.date)}
                        <h2 className="broker-today-keys__article-subtitle">
                            {article.subtitle}
                        </h2>
                        <p className="broker-today-keys__article-description">
                            {article.description}
                        </p>
                    </section>
                </article>
            );
        });

        return (
            <ContentBox
                id="brokerTodayKeys"
                customClassName="broker-today-keys"
            >
                <section className="broker-today-keys__section">
                    {articlesBlock}
                </section>
            </ContentBox>
        );
    }
}

BrokerTodayKeys.propTypes = {
    brokerTodayNews: PropTypes.func
}

module.exports.constructor = BrokerTodayKeys;
module.exports.BrokerTodayKeys = connect(
    state => ({
        brokerTodayNews: state.brokerTodayNews,
    })
)(BrokerTodayKeys);